import { TYPE_TO_KEY } from '../common/territory.consts'

export const useTerritoryTableCell = ({ row, index }) => {
  const [entityType, id] = row?.territoryId?.split('.') ?? []
  const highlightText = row?.highlight

  const addToItem = {
    id,
    name: row?.name,
    type: TYPE_TO_KEY?.[entityType] ?? entityType,
  }

  return {
    index: index + 1,
    entityType,
    id,
    addToItem,
    highlightText,
    name: row?.name,
    breadcrumbItems: row?.breadcrumbItems,
  }
}
